// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","small":"(min-width:600px)","medium":"(min-width:768px)","medium-max":"(max-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wide":"(min-width:1600px)","easeOutQuad":"cubic-bezier(.25,.46,.45,.94)","content":"letters__content___2rUcC layout__homeContent___1jyyH","svg":"letters__svg___1hCt4","eContainer":"letters__eContainer___3hqTF","gContainer":"letters__gContainer___10_92","iContainer":"letters__iContainer___IdN7s","rContainer":"letters__rContainer___7CB8y","sContainer":"letters__sContainer___-mAZc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Letters/letters.css
// module id = 160
// module chunks = 0